import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"

import NoResults from "./NoResults"
import Products from "./Products"
import Toolbar from "./Toolbar"
import Sidebar from "./Sidebar"
import BottomToolbar from "./BottomToolbar"
import SelectedFilters from "./SelectedFilters"
import Loader from "./elements/Loader"
import { useEffect } from "preact/hooks"




export default function Serp() {
    const {
        response: { products },
        loading
    } = useAppState()
    const foundProducts = products && products.total > 0
    const toggleButtonId = "toggle-mobile-sidebar"

    useEffect(()=>{

        // function checkJquery(){
        //     if(typeof jQuery === "function"){
        //         jQuery(".nosto-togglebutton-container").appendTo(jQuery(".results-navbar__row"))
        //         jQuery(".ns-header-controls").remove();
        //      }else{
        //       setTimeout(checkJquery, 1000);
        //     }
        //   }
        //   checkJquery();
        document.querySelector(".results-navbar__row")
    ?.appendChild(document.querySelector(".nosto-togglebutton-container"));

    document.querySelector(".ns-header-controls")?.remove();

        
    })

    return (
        <div
            class="ns-serp ns-d-flex ns-flex-column ns-flex-md-row ns-font-inherit ns-pb-4 ns-my-0 ns-mx-auto"
            data-nosto-element="search"
        >
            {(foundProducts || (loading && foundProducts)) && <Sidebar toggleId={toggleButtonId} />}
            <div
                class="ns-d-block ns-d-md-inline ns-w-100 ns-border-box ns-p-0"
                style={loading ? "position: relative;" : ""}
            >
                {foundProducts ? (
                    <>
                        <Toolbar style="display:none;" lableFor={toggleButtonId} />
                        <Products />
                        <BottomToolbar />
                    </>
                ) : loading ? (
                    <Loader />
                ) : (
                    <NoResults />
                )}

                {/* To enable InfiniteScroll - comment above block and uncomment below.
                    Don't forget to import InfiniteScroll component. */}
                {/* {foundProducts ? (
                    <>
                        <SelectedFilters />
                        <Toolbar />
                        <InfiniteScroll>
                            <Products />
                        </InfiniteScroll>
                    </>
                ) : loading ? (
                    <Loader />
                ) : (
                    <NoResults />
                )} */}
            </div>
        </div>
    )
}
